import React from "react";

/**
 * BrandLogo — custom SVG untuk "Aplikasi Kontrakan Surbakti".
 * Motif: rumah beratap segitiga + 2 jendela (multi-unit) + pintu.
 * Warna body = currentColor (mengikuti class text-primary-foreground di sidebar,
 * atau text-primary di area terang). Detail jendela/pintu memakai fill hardcoded
 * putih + opacity supaya kontras kuat di background primary.
 */
export function BrandLogo({ className = "", ...props }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* Body & roof (solid) */}
      <path
        d="M16 3.2L4 12.4v14.2a1.6 1.6 0 001.6 1.6h20.8a1.6 1.6 0 001.6-1.6V12.4L16 3.2z"
        fill="currentColor"
      />
      {/* Left window */}
      <rect x="7.5" y="15.4" width="5" height="5" rx="1.1" fill="#ffffff" opacity="0.95" />
      <line x1="10" y1="15.4" x2="10" y2="20.4" stroke="currentColor" strokeWidth="0.7" />
      <line x1="7.5" y1="17.9" x2="12.5" y2="17.9" stroke="currentColor" strokeWidth="0.7" />
      {/* Right window */}
      <rect x="19.5" y="15.4" width="5" height="5" rx="1.1" fill="#ffffff" opacity="0.95" />
      <line x1="22" y1="15.4" x2="22" y2="20.4" stroke="currentColor" strokeWidth="0.7" />
      <line x1="19.5" y1="17.9" x2="24.5" y2="17.9" stroke="currentColor" strokeWidth="0.7" />
      {/* Door */}
      <path
        d="M14 28.2v-5.6a2 2 0 012-2h0a2 2 0 012 2v5.6h-4z"
        fill="#ffffff"
        opacity="0.95"
      />
      {/* Door knob */}
      <circle cx="17" cy="25" r="0.35" fill="currentColor" />
    </svg>
  );
}

export default BrandLogo;
